const Footer = () =>{
        return(
        <footer className="site-footer">
            <p>© {new Date().getFullYear()} Cliff Mutinda. All rights reserved.</p>
            <p className="body-text">Built with React • Secured by thoughtful engineering</p>
        </footer>
    )
}

export default Footer;